import storage from 'good-storage'
// import router from './router'

// // 路由守卫 
// router.beforeEach((to,from,next)=>{
// 	console.log(111);
// 	let flag = false
// // to.meta.requireAuth == 

// 	console.log(to);
// 	if(to.name=="operate"){ // 需要登录权限进入的路由
// 		if(!flag){     // 获取不到登录信息
// 			next({
// 				path: '/login'
// 			})
// 		}else{      // 获取到登录信息，进行下一步
// 			return next();
// 		}
// 	}else{       // 不需要登录权限的路由直接进行下一步
// 		return next();
// 	}
// })

//权限校验
function checkPermission(el, binding) {
	const { value } = binding
	const permiss =JSON.parse(localStorage.getItem('permiss'))
	if (value && value instanceof Array) {
		if (value.length > 0) {
		  const permissionRoles = value
			var hasPermission
			if(permiss){
				hasPermission = permiss.some(p => {
					if(p=="*"){//*代表所有权限
					  return true;
					}
					
					return permissionRoles.includes(p.perms)
				})
			}else{
				hasPermission = false;
			}

			if (!hasPermission) {
				el.parentNode && el.parentNode.removeChild(el)
			}
		}
	} else {
		throw new Error(`need roles! Like v-permission="['admin','editor']"`)
	}
}

const permission = {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}

const install = function(Vue) {
  Vue.directive('permission', permission)
}

if (window.Vue) {
  window['permission'] = permission
  Vue.use(install); // eslint-disable-line
}

permission.install = install
export default permission
